import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M9.21681 0L8.41266 0.672477L11.8233 3.52464H0V4.47536H11.8233L8.41266 7.32752L9.21681 8L14 4.00063L9.21681 0.00126754V0Z",
	fill: "#999999"
}));
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
